import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { mockAddressDetails, mockBillingDetails, mockInvalidBillingDetails, mockInvalidShippingAddress, mockInternationalShippingAddress } from '../../../mocks/address.js';
import { checkIsGooglePayCheckout, checkIsApplePayExpressCheckout, checkIsApplePayStandardCheckout } from '../../../utils/paymentMethod.js';
import { fieldsetStyle } from '../styles.js';
var StubbedAddressActions = function StubbedAddressActions(_ref) {
  var onConfirm = _ref.onConfirm,
    paymentMethodType = _ref.paymentMethodType;
  var _useMemo = useMemo(function () {
      return {
        isApplePayStandardCheckout: checkIsApplePayStandardCheckout(paymentMethodType),
        isApplePayExpressCheckout: checkIsApplePayExpressCheckout(paymentMethodType),
        isGooglePayCheckout: checkIsGooglePayCheckout(paymentMethodType)
      };
    }, [paymentMethodType]),
    isApplePayStandardCheckout = _useMemo.isApplePayStandardCheckout,
    isApplePayExpressCheckout = _useMemo.isApplePayExpressCheckout,
    isGooglePayCheckout = _useMemo.isGooglePayCheckout;
  return jsxs("fieldset", {
    style: fieldsetStyle,
    children: [jsx("legend", {
      children: "Stubbed address options"
    }), isApplePayExpressCheckout && jsxs(Fragment, {
      children: [jsx("strong", {
        style: {
          width: '100%'
        },
        children: "Happy path"
      }), jsx("button", {
        onClick: function onClick() {
          return onConfirm({
            billingDetails: mockBillingDetails,
            shippingAddress: mockAddressDetails
          });
        },
        children: "Valid Billing and Shipping Address"
      }), jsx("strong", {
        style: {
          width: '100%'
        },
        children: "Billing Address"
      }), jsx("button", {
        onClick: function onClick() {
          return onConfirm({
            billingDetails: mockInvalidBillingDetails,
            shippingAddress: mockAddressDetails
          });
        },
        children: "Invalid Billing Address"
      }), jsx("button", {
        onClick: function onClick() {
          return onConfirm({
            billingDetails: '',
            shippingAddress: mockAddressDetails
          });
        },
        children: "Missing Billing Address"
      }), jsx("strong", {
        style: {
          width: '100%'
        },
        children: "Shipping Address"
      }), jsx("button", {
        onClick: function onClick() {
          return onConfirm({
            billingDetails: mockBillingDetails,
            shippingAddress: mockInvalidShippingAddress
          });
        },
        children: "Invalid Shipping Address"
      }), jsx("button", {
        onClick: function onClick() {
          return onConfirm({
            billingDetails: mockBillingDetails,
            shippingAddress: mockInternationalShippingAddress
          });
        },
        children: "International Shipping Address"
      }), jsx("button", {
        onClick: function onClick() {
          return onConfirm({
            billingDetails: mockBillingDetails,
            shippingAddress: ''
          });
        },
        children: "Missing Shipping Address"
      })]
    }), (isApplePayStandardCheckout || isGooglePayCheckout) && jsxs(Fragment, {
      children: [jsx("button", {
        onClick: function onClick() {
          return onConfirm({
            billingDetails: mockBillingDetails
          });
        },
        children: "Valid Address"
      }), jsx("button", {
        onClick: function onClick() {
          return onConfirm({
            billingDetails: mockInvalidBillingDetails
          });
        },
        children: "Invalid Address"
      })]
    })]
  });
};
export { StubbedAddressActions as default };